<style lang="scss" scoped>
.nav-bar {
  position: fixed;
  top: 0;
  left: 0;
  z-index: $z-navigation-bar;

  width: 100%;
}

.person-info,
.person-info-tip {
  font-size: 0.28rem;
}
.person-info {
  background-color: #fff;
  .item {
    display: flex;

    padding: 0.24rem 0.32rem;

    border-bottom: 1px solid #fafafa;

    justify-content: space-between;
    align-items: center;
    .title {
      flex: none;
    }
    .text {
      width: 4.6rem;

      text-align: right;
      color: #8c8c8c;
    }
    :last-child {
      border-bottom: none;
    }
  }
}
.person-info-tip {
  padding: 0.2rem 0.32rem 0 0.32rem;

  color: #8c8c8c;
}
.person-info-scroll-view {
  padding-top: 0.2rem;
}
</style>

<template>
  <page
    :custom-style="{
      display: 'flex',
      'flex-direction': 'column',
      'background-color': '#fff',
      height: '100vh',
      'padding-top': pagePaddingTop
    }"
  >
    <maple-nav-bar
      v-if="!browerInfo.isMiniProgram"
      :safe-top-distance="statusBarHeight"
      class="nav-bar"
      left-arrow
      title="商家经营信息"
      @click-left="goBack"
    />
    <scroll-view :background="'#F5F5F5'" class="person-info-scroll-view">
      <ul class="person-info">
        <li class="item">
          <div class="title">店铺名称</div>
          <div class="text">{{ personShopInfo.shopName }}</div>
        </li>
        <li class="item">
          <div class="title">经营地址</div>
          <div class="text">{{ personShopInfo.address }}</div>
        </li>
        <li class="item">
          <div class="title">联系方式</div>
          <div class="text">{{ personShopInfo.contactPhone }}</div>
        </li>
      </ul>
      <p class="person-info-tip">{{ personShopInfo.personalTip }}</p>
    </scroll-view>
  </page>
</template>

<script>
import { mapState } from 'vuex'
import { miniProgramEnv } from '@/defines/environment'
import ScrollView from '@/common/widgets/scroll_view'
export default {
  name: 'PersonShopInfo',
  components: {
    ScrollView
  },
  data() {
    return {
      browerInfo: window.matrix
    }
  },
  computed: {
    ...mapState('pop', ['personShopInfo']),
    pagePaddingTop() {
      if (!miniProgramEnv.isMiniProgram) {
        return 44 + this.statusBarHeight + 'px'
      } else {
        return '0px'
      }
    }
  },

  methods: {
    goBack() {
      this.$back()
    }
  }
}
</script>
